import { render, staticRenderFns } from "./OrdersCountsContainer.vue?vue&type=template&id=6c8b16a2&scoped=true&"
import script from "./OrdersCountsContainer.vue?vue&type=script&lang=js&"
export * from "./OrdersCountsContainer.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCountsContainer.vue?vue&type=style&index=0&id=6c8b16a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b16a2",
  null
  
)

component.options.__file = "OrdersCountsContainer.vue"
export default component.exports